/* eslint-disable functional/no-class, functional/no-mixed-type, functional/no-this-expression -- React 16 error boundaries require a class. */
import React, { Component, ReactNode } from "react";
import { reportBrowserError } from "../../services/browser-telemetry";

class BrowserErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidCatch(error: Error): void {
    reportBrowserError(error);
  }

  render(): ReactNode {
    const { failed } = this.state;
    const { children } = this.props;

    if (failed) {
      return (
        <div role="alert">
          <p>Unable to display the application. Please reload and try again.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }

    return children;
  }
}

export { BrowserErrorBoundary };
